import { ActionIcon, Group } from '@mantine/core';
import { IconEye, IconFileDownload, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

type AttachmentActionButtonsProps = {
  onPreview: () => void;
  onDownload: () => void;
  onRemove?: () => void;
  previewLoading?: boolean;
  downloadLoading?: boolean;
  showPreview?: boolean;
  showDownload?: boolean;
  showRemove?: boolean;
};

export function AttachmentActionButtons({
  onPreview,
  onDownload,
  onRemove,
  previewLoading = false,
  downloadLoading = false,
  showPreview = true,
  showDownload = true,
  showRemove = false,
}: AttachmentActionButtonsProps) {
  const { t } = useTranslation();

  return (
    <Group spacing="xs" noWrap>
      {showPreview && (
        <ActionIcon
          onClick={onPreview}
          loading={previewLoading}
          variant="light"
          title={t('common.attachments.preview')}
          sx={{
            backgroundColor: 'rgba(48,113,91,0.2)',
            width: '32px',
            height: '32px',
          }}
        >
          <IconEye size={16} />
        </ActionIcon>
      )}
      {showDownload && (
        <ActionIcon
          onClick={onDownload}
          loading={downloadLoading}
          variant="light"
          title={t('common.attachments.download')}
          sx={{
            backgroundColor: 'rgba(48,113,91,0.2)',
            width: '32px',
            height: '32px',
          }}
        >
          <IconFileDownload size={16} />
        </ActionIcon>
      )}
      {showRemove && onRemove && (
        <ActionIcon
          color="red"
          onClick={onRemove}
          variant="light"
          title={t('tasks.form.remove')}
          sx={{
            backgroundColor: 'rgba(48,113,91,0.2)',
            width: '32px',
            height: '32px',
          }}
        >
          <IconTrash size={16} />
        </ActionIcon>
      )}
    </Group>
  );
}
